import { isEmptyObject } from 'jquery';

export const getFirstLetter=(value:any)=> {
    if(!isEmptyObject(value)) return value.slice(0,1);
    return '';
}